export const customStylesZona = () => ({
    control: (provided) => ({
        ...provided,
        width: 120,
        transition: 'width 0.3s ease',
        fontWeight: 600, // Semibold
        backgroundColor: '#d3d3d3'
    }),
    menu: (provided) => ({
        ...provided,
        width: 120,
        fontWeight: 600, // Semibold
        backgroundColor: '#d3d3d3', // Gris claro
        color: 'black' // Letra negra
    }),
    singleValue: (provided) => ({
        ...provided,
        fontWeight: 600 // Semibold
    }),
    option: (provided) => ({
        ...provided,
        fontWeight: 600 // Semibold
    })
  });